import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { companyManagementUrl } from "../../../config";
import { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import { CompanyColumns } from "../../../data/DynamicTable/CompanyManagementColumns";
import { allCompanies } from "../../../data/Axios/queries"; 
import CompanyForm from "./form";
import { generateAndExecuteMutation } from "../../../data/Axios/DynamicService";

const base_url = companyManagementUrl.uri;

const actions = {
  entity: "Companies",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "activateDeactivate",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "companyIds",
    inputObjectName: "bulkActivateDeactivateCompany",
  },
  showMore: {
    key: "SHOWMORE",
    button_name: "Show More",
    Show_Button: true,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
    title: "Company Details"
  },
  required: "CompanyIds",
  showStatus: true,
};

function CompanyTable() {
  const [companies, setCompanies] = useState(allCompanies); 

  // const handleActivateDeactivate = async (active, id) => {
  //   try {
  //     const confirmation = await Swal.fire({
  //       title: "Are you sure?",
  //       text: `Do you want to ${active ? "deactivate" : "activate"} ${actions.entity}?`,
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonText: `Yes, ${active ? "deactivate" : "activate"} it!`,
  //       cancelButtonText: "No, keep it",
  //     });

  //     if (confirmation.isConfirmed) {
  //       const mutationData = {
  //         [actions.activateDeactivate.modelName]: [id],
  //         isActive: !active, 
  //       };

  //       const response = await generateAndExecuteMutation(
  //         actions.activateDeactivate.inputObjectName,
  //         mutationData,
  //         null,
  //         base_url
  //       );

  //       if (response && Object.keys(response).length > 0) {
  //         Swal.fire({
  //           icon: "success",
  //           title: "Success!",
  //           text: `${actions.entity} ${active ? "deactivated" : "activated"} successfully.`,
  //         });

  //         setCompanies((prev) =>
  //           prev.map((company) =>
  //             company.id === id ? { ...company, active: !active } : company
  //           )
  //         );
  //       }
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error!",
  //       text: "An error occurred while processing your request. Please try again later.",
  //     });
  //   }
  // };

  // const modifiedColumns = CompanyColumns.map((column) => {
  //   if (column.field === "action") {
  //     return {
  //       ...column,
  //       renderCell: (params) => {
  //         const active = params.row.active === 1; // Check if the company is active
  //         return (
  //           <button onClick={() => handleActivateDeactivate(active, params.row.id)}>
  //             {active ? "Deactivate" : "Activate"}
  //           </button>
  //         );
  //       },
  //     };
  //   }
  //   return column;
  // });

  return (
    <Box m="2px">
      <DynamicTable
        title="Company"
        subtitle="Create, view or edit account Company"
        columns={CompanyColumns}
        FormComponent={CompanyForm}
        query={companies} 
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default CompanyTable;
